module.exports = __webpack_public_path__ + "img/logo-onebox-mobile.4e1f1753.png";